module.exports = __webpack_public_path__ + "static/media/asuntoscorporativos.fe1fe87e.jpg";